import React from 'react';

export enum ContentIds {
    MEDIA_FORM = 'mediaForm',
    DISPLAY_MEDIA = 'displayMedia',
}

export interface ISubmitHandler {
    setContentData: React.Dispatch<React.SetStateAction<Object>>;
    contactId: string;
    fromAccountActivity?: boolean;
}

export interface IMediaFormSchema {
    interactionId: number;
}